import Service from '@/service/index.js';
export default {
  components: {
  },
  props: {
    userInfo: {
      type: Object,
      default: {}
    },
    projectInfo: {
      type: Object,
      default: {}
    },
    type: {
    },
    transfereeInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      managementSubjectCodeArr: [],
      transferTypeArr: [],
      payTypeArr: [],
      circulationTypeCodeArr: [],
      tradeTypeArr: [],
      contractorPriorityCodeArr: [],
      bidTypeArr: [],
      projectPurposeArr: [],
      landtypeArr: []
    };
  },
  created() {
    const obj = {
      MANAGEMENT_SUBJECT: 'managementSubjectCodeArr',
      TRANSFER_TYPE: 'transferTypeArr',
      PAY_TYPE: 'payTypeArr',
      BIDDING_METHOD: 'bidTypeArr',
      CIRCULATION_TYPE: 'circulationTypeCodeArr',
      TRADE_TYPE: 'tradeTypeArr',
      CONTRACTOR_PRIORITY: 'contractorPriorityCodeArr',
      PROJECT_PURPOSE: 'projectPurposeArr',
      LAND_CATEGORY: 'landtypeArr'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;

        }
      });
    });
  },
  mounted() {
    // console.log(this.projectInfo, 'projectInfo');
    // if(this.projectInfo) {
    //   this.contractorPriorityCodeArr = this.contractorPriorityCodeArr.filter(item => this.projectInfo.contractorPriorityCode.inclues(item.code));
    // }
  },
  computed: {
    projectCode() {
      if(this.projectInfo && this.projectInfo.projectType && this.projectInfo.projectSubType) {
        return `${this.projectInfo.projectType}-${this.projectInfo.projectSubType}`;
      }
    }
  },
  methods: {
    toExtendDetail() {
      this.$router.push('/notice-modular/trading-rules-detail?id=' + this.projectInfo.newsId);
    }
  }
};
